import React from "react";
import { Card, CardHeader, Checkbox, Text, makeStyles, mergeClasses, tokens } from "@fluentui/react-components";
import { useGlobalStyles } from "../../utils/Theming";

const useStyles = makeStyles({
  card: {
    padding: "6px",
    marginBottom: "0",
    borderTop: `1px solid ${tokens.colorNeutralStroke1}`,
    borderRadius: "0",
    boxShadow: "none",
    ":last-child": {
      borderBottom: `1px solid ${tokens.colorNeutralStroke1}`,
    },
  },
  cardLabel: {
    maxWidth: "200px",
  },
  resultType: {
    fontSize: "12px",
    color: tokens.colorNeutralForeground3,
  },
});

const ResultCard = ({ item, checked, onChange }) => {
  const styles = useStyles();
  const globalStyles = useGlobalStyles();

  return (
    <Card key={`${item.uid}-${item.entityId}`} className={styles.card}>
      <CardHeader
        header={<Text weight="medium" className={mergeClasses(globalStyles.truncateText, styles.cardLabel)}>{item.label}</Text>}
        description={<Text className={styles.resultType}>{item.type}</Text>}
        action={<Checkbox checked={checked} onChange={onChange} />}
      />
    </Card>
  );
};

export default ResultCard;
